export default [
    {
        path: '/musteri-ara',
        name: 'musteri-ara',
        meta: { resource: 'admin|dealer|callcenter|personel' },
        component: () => import('../views/customer/kb_search'),
    },
    {
        path: '/on-kayit-ekle',
        name: 'on-kayit-ekle',
        meta: { resource: 'admin|dealer|callcenter|personel' },
        component: () => import('../views/customer/create'),
    },
    {
        path: '/kurulum-bekleyenler',
        name: 'kurulum-bekleyenler',
        meta: { resource: 'admin|dealer|personel' },
        component: () => import('../views/customer/list'),
    },
    {
        path: '/uzatmayanlar',
        name: 'uzatmayanlar',
        meta: { resource: 'admin|dealer|personel' },
        component: () => import('../views/customer/uzatmayanlar'),
    },
    {
        path: '/kayip-listesi',
        name: 'kayip-listesi',
        meta: { resource: 'admin|dealer|personel' },
        component: () => import('../views/customer/kayip'),
    },
    {
        path: '/sokulemeyen-listesi',
        name: 'sokulemeyen-listesi',
        meta: { resource: 'admin|dealer|personel' },
        component: () => import('../views/customer/sokulemeyen'),
    },
    {
        path: '/tasima-listesi',
        name: 'tasima-listesi',
        meta: { resource: 'admin|personel' },
        component: () => import('../views/customer/tasima'),
    },
    {
        path: '/kurulamayanlar-listesi',
        name: 'kurulamayanlar-listesi',
        meta: { resource: 'admin|personel' },
        component: () => import('../views/customer/kurulamayanlar'),
    },
]